import { getToken, setUser } from "../utils/comman/Common";
import axiosinstances from "../Helper/useAxios";
import { useSelector } from "react-redux";

export async function getbalanceresponse(data, userIp) {
  const [axiosInstance] = axiosinstances(userIp);
  //console.log('idid',id)
  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  const e = JSON.parse(sessionStorage.getItem("token"));
  return axiosInstance
    .get(`/api/v1/upi/merchant/wallet/get/${data?.id}`, {
      headers: data?.headers,
    })
    .then((response) => {
      if (response) {
        const { data } = response;

        return data;
      }
      return false;
    })
    .catch((err) => {
      //console.log(err);
    });
}

// const fetchBalance = async () => {
//     setBalanceLoader(true);
//     try {
//       const response = await axiosInstance.get(
//         `/api/v1/upi/merchant/wallet/get/${mid}`,
//         {
//           headers,
//         }
//       );
//       setBalance(response.data);
//     } catch (error) {
//       toast.error("Error in fetch balance");
//     }
//     setBalanceLoader(false);
//   };
